// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "225e686bdcf8ba7d","396": "45d102920aec3190","460": "46ea7275872717ac","917": "a9af05a3e316033d","985": "8e10b02d9b7d680c",}[chunkId] + ".chunk.js"
}